// extracted by mini-css-extract-plugin
export default {"grandOpeningTag":"FridgeLocationTags-module--grandOpeningTag--c84d2","mobileAppDiscountTag":"FridgeLocationTags-module--mobileAppDiscountTag--0bdad"};